import produce from "immer";
import { create } from "zustand";
import * as api from "../services/settings";

export const useSettingsStore = create((set, get) => ({
  env: null,
  translation: null,
  whitelabel: null,
  features: {},
  isLoading: true,
  fetchWhitelabeling: async () => {
    set(
      produce((draft) => {
        draft.isLoading = true;
      }),
    );
    const resp = await api.getWhitelabel();
    set(
      produce((draft) => {
        draft.whitelabel = resp.data;
        draft.isLoading = false;
      }),
    );
    return resp;
  },
  fetchTranslation: async () => {
    set(
      produce((draft) => {
        draft.isLoading = true;
      }),
    );
    const resp = await api.getTranslation();
    set(
      produce((draft) => {
        draft.translation = resp.data;
        draft.isLoading = false;
      }),
    );
    return resp;
  },
  fetchFeatures: async () => {
    const resp = await api.getFeatures();
    set(
      produce((draft) => {
        draft.features = resp.data || {};
      }),
    );
    return resp;
  },
  updateTranslation: async (payload) => {
    const { data, error } = await api.updateTranslationOverrides(payload);
    if (!error) {
      set(
        produce((draft) => {
          draft.translation = data;
        }),
      );
    }
    return { data, error };
  },
  fetchEnv: async () => {
    set(
      produce((draft) => {
        draft.isLoading = true;
      }),
    );
    const resp = await api.getEnv();
    set(
      produce((draft) => {
        draft.env = resp.data;
        draft.isLoading = false;
      }),
    );
    return resp;
  },
}));
